import { SxStyleProp } from 'theme-ui';

export const CenteredContainer: SxStyleProp = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: ['column', 'row'],
  height: '100%',
};

export const StyledText: SxStyleProp = {
  color: '#FFF',
  marginRight: [null, '57px'],
  marginBottom: ['32px', 'inherit'],
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitLineClamp: ['2', '1'],
  WebkitBoxOrient: ['vertical'],
  textAlign: ['center', 'left'],
  maxWidth: ['270px', 'revert'],
};

export const StyledIframe: SxStyleProp = {
  width: ['292px', '490px'],
  height: ['150px', '48px'],
};
